module.exports = {
	"START": "開始",
	"SINGLE_TYPED": "單一屬性",
	"DOUBLE_TYPED": "雙重屬性",
	"BASIC": "一般遊玩",
	"SPEEDRUN": "時間競速",
	"HOME": "首頁",
	"ATTACK": "攻擊",
	"DEFEND": "防禦",
	"GOAL": "目標",
	"GOAL_BASIC": "在 60 秒內答題",
	"GOAL_SPEEDRUN": "達到 20 分",
	"TIMER": "倒數",
	"SCORES": "分數",
	"YOUR_SCORES": "您的分數",
	"YOUR_TIME": "您的時間",
	"RETRY": "重玩",
	"MENU": "目錄",
	"LANGUAGE": "語言",
	"NORMAL": "一般",
	"FIGHTING": "格鬥",
	"FLYING": "飛行",
	"POISON": "毒",
	"GROUND": "地面",
	"ROCK": "岩石",
	"BUG": "蟲",
	"GHOST": "幽靈",
	"STEEL": "鋼",
	"FIRE": "火",
	"WATER": "水",
	"GRASS": "草",
	"ELECTRIC": "電",
	"PSYCHIC": "超能力",
	"ICE": "冰",
	"DRAGON": "龍",
	"DARK": "惡",
	"FAIRY": "妖精",
	"EFFECTIVE_0": "没有效果",
	"EFFECTIVE_1_2": "效果不理想",
	"EFFECTIVE_1": "效果一般",
	"EFFECTIVE_2": "效果絕佳",
	"ENEMY_ATTACK": "攻擊敵人",
	"ENEMY_DEFEND": "防禦來自敵人的攻擊"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/lang/strings_zh.json
 ** module id = 322
 ** module chunks = 0
 **/